import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { cn } from '@/lib/utils';

interface RolePermission {
    role: string;
    description: string;
}

interface RolePermissionsCardProps {
    title?: string;
    permissions?: RolePermission[];
    /** Optional className override for the outer card (rare). */
    className?: string;
}

const defaultPermissions: RolePermission[] = [
    {
        role: 'Admin',
        description: 'Full control over company account, manages all users, services, and settings.'
    },
    {
        role: 'Sales Manager',
        description: 'Oversees Sales Representatives, reviews their intake forms, and requests architectural services.'
    },
    {
        role: 'Sales Representative',
        description: 'Manages customer interactions, fills out intake forms, and submits project scopes.'
    },
    {
        role: 'Estimator',
        description: 'Reviews intake forms, approves/denies estimates, and creates project proposals.'
    }
];

export function RolePermissionsCard({
    title = 'User Role Permissions',
    permissions = defaultPermissions,
    className,
}: RolePermissionsCardProps) {
    return (
        <Card className={cn('border border-border bg-muted', className)}>
            <CardHeader>
                <h3 className="font-newsreader text-xl font-semibold tracking-tight tracking-tight text-foreground">
                    {title}
                </h3>
            </CardHeader>
            <CardContent>
                <div className="space-y-3">
                    {permissions.map((permission, index) => (
                        <div key={index} className="flex flex-col sm:flex-row gap-2">
                            <span className="font-medium text-foreground min-w-[160px] text-sm">
                                {permission.role}:
                            </span>
                            <span className="text-foreground text-sm">
                                {permission.description}
                            </span>
                        </div>
                    ))}
                </div>
            </CardContent>
        </Card>
    );
}
